module.exports = __webpack_public_path__ + "img/840.dc33d471.svg";